import React, { useState, useEffect } from "react";
import { Stripe, loadStripe } from '@stripe/stripe-js';
import { getImageBasic } from "src/apiCalls";
import {
  Route,
  Routes,
} from "react-router-dom";
import { PaidForContent } from "./return";
import { Typography } from "@mui/material";
import { getStripeAccountId } from "src/apiCalls";
import LocationDisplay from "./locationDisplay";
import logger from 'src/logger';
// Type definitions
interface CheckoutFormProps {
  imageId: string;
  stripeAccountId: string;
}

interface PaidComponentProps {
  imageId: string;
}

interface StripeAccountResponse {
  stripeAccountId: string;
}

export const CheckoutForm = ({ imageId, stripeAccountId }) => {
  const [error, setError] = useState(null);
  const [imageData, setImageData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const basicData = await getImageBasic(imageId);
        setImageData(basicData);
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'An error occurred';
        logger.error('Error fetching data:', errorMessage);
        setError(errorMessage);
      }
    };

    fetchData();
  }, [imageId]);

  if (error) {
    return <Typography color="error">Error: {error}</Typography>;
  }

  if (!imageData) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <div id="checkout" style={{ width: '95%', maxWidth: '1200px', margin: '0 auto' }}>
      {/* <Card sx={{ width: '100%', maxWidth: { xs: '100%', sm: 800, md: 1000 }, mx: 'auto', mb: 3 }}>
        <CardContent> */}
          {/* Your existing image details content */}
          <LocationDisplay 
            imageData={imageData}
            stripeAccountId={stripeAccountId}
          />
        {/* </CardContent>
      </Card> */}
    </div>
  );
};

export const PaidComponent: React.FC<PaidComponentProps> = ({ imageId }) => {
  const [stripeAccountId, setStripeAccountId] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStripeAccount = async (): Promise<void> => {
      try {
        const response: StripeAccountResponse = await getStripeAccountId(imageId);
        logger.info('Fetched Stripe Account ID:', response.stripeAccountId);
        setStripeAccountId(response.stripeAccountId);
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'An error occurred';
        logger.error('Error fetching Stripe Account ID:', errorMessage);
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchStripeAccount();
  }, [imageId]);

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  if (error) {
    return <Typography color="error">Error: {error}</Typography>;
  }
  return <CheckoutForm imageId={imageId} stripeAccountId={stripeAccountId} />;
  // return (
  //   <div className="App">
  //     <Routes>
  //       <Route path="/" element={<CheckoutForm imageId={imageId} stripeAccountId={stripeAccountId} />} />
  //       <Route path="/return" element={<Return />} />
  //     </Routes>
  //   </div>
  // );
};

export default PaidComponent;